export default __webpack_public_path__ + "static/media/chatton16.4ca30a53.jpg";